import React, { Fragment } from "react";

const BreadCrumbTwo = () => {
  return (
    <Fragment>
      <section
        id="breadcrumb-section"
        className="breadcrumb-section mma-container clearfix"
        style={{
          backgroundImage: `url('assets/images/breadcrumb/bg-image-2.jpg')`,
        }}
      >
        <div className="overlay-black"></div>
      </section>
    </Fragment>
  );
};

export default BreadCrumbTwo;
